import { AbstractControl, ValidatorFn } from '@angular/forms';

export const email = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } => {
        const isValid = /^([_a-z0-9+\-\.]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/.test(control.value);

        return isValid ? null : { email: true };
    };
};
